<template lang="html">
	<wizard-screen :completed="2" :total="5" :nav-next="isDisabled ? 'disabled' : true">
		<h2>What’s your goal with OptinMonster?</h2>
		<div class="omapi-happy-text">Please select all that apply.</div>
		<div class="omapi-radio-group__row">
			<common-selectable-group group-name="goal" type="checkbox" :options="goalGroup1" @input="setValue" />

			<common-selectable-group group-name="goal" type="checkbox" :options="goalGroup2" @input="setValue" />
		</div>
	</wizard-screen>
</template>

<script lang="js">
import { screen } from './mixins/screen'

export default {
	mixins   : [ screen ],
	computed : {
		goalGroup1 () {
			return this.mapToRadios(this.goalMap.slice(0, 3), 'onboardingGoal')
		},
		goalGroup2 () {
			return this.mapToRadios(this.goalMap.slice(3), 'onboardingGoal')
		},
		isDisabled () {
			return !this.$get('onboardingGoal', []).length
		},
	},
	methods : {
		mapToRadios (data) {
			return data.map(t => ({
				label   : t.title,
				value   : t.slug,
				checked : this.$get('onboardingGoal', []).includes(t.slug),
			}))
		},
	},
};
</script>
